/* IntelApps — Why choose us */
import React from 'react';
import { useI18n } from '../i18n.js';

export default function WhyChooseUs() {
  const { t } = useI18n();
  const { reasons } = t.whyUs;

  return (
    <section className="section" id="why-us" style={{ paddingTop: 0 }}>
      <div className="container">
        <div className="section-head">
          <div>
            <span className="eyebrow">{t.whyUs.eyebrow}</span>
            <h2>{t.whyUs.title}</h2>
          </div>
          <p>{t.whyUs.description}</p>
        </div>
        <div className="why-grid">
          {reasons.map((r, i) => (
            <article key={r.title} className="why-card">
              <span className="why-card-num" aria-hidden="true">
                {String(i + 1).padStart(2, '0')}
              </span>
              <h3>{r.title}</h3>
              <p>{r.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
